export default __webpack_public_path__ + "static/media/swipe-hand.88d9dd6b.svg";